module.exports = __webpack_public_path__ + "media/promovide.eeb65efe.mp4";